// Central content + media for the Interlocked Solutions x FireFlink landing page.

export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1774791242463-ad4fd6386cb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhdGElMjBmbG93JTIwZGFyayUyMHRlY2h8ZW58MHx8fHwxNzg2MTQxMzU4fDA&ixlib=rb-4.1.0&q=85",
  dashboard:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxBSSUyMHNvZnR3YXJlJTIwdGVzdGluZyUyMGRhc2hib2FyZCUyMGRhcmslMjBpbnRlcmZhY2V8ZW58MHx8fHwxNzg2MTQxNDI4fDA&ixlib=rb-4.1.0&q=85",
  monitoring:
    "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxBSSUyMHNvZnR3YXJlJTIwdGVzdGluZyUyMGRhc2hib2FyZCUyMGRhcmslMjBpbnRlcmZhY2V8ZW58MHx8fHwxNzg2MTQxNDI4fDA&ixlib=rb-4.1.0&q=85",
  serverCloud:
    "https://images.unsplash.com/photo-1680992046617-e2e35451bcdb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxzZXJ2ZXIlMjByb29tJTIwZnV0dXJpc3RpY3xlbnwwfHx8fDE3ODYxNDEzNTh8MA&ixlib=rb-4.1.0&q=85",
  ukSkyline:
    "https://images.unsplash.com/photo-1651430459910-574130c46511?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxMb25kb24lMjB0ZWNoJTIwb2ZmaWNlJTIwc2t5bGluZSUyMGRhcmt8ZW58MHx8fHwxNzg2MTQxNDI4fDA&ixlib=rb-4.1.0&q=85",
  avatar1:
    "https://images.unsplash.com/photo-1609436132311-e4b0c9370469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBkYXJrfGVufDB8fHx8MTc4NjE0MTQyOHww&ixlib=rb-4.1.0&q=85",
  avatar2:
    "https://images.unsplash.com/photo-1769636929261-e913ed023c83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBkYXJrfGVufDB8fHx8MTc4NjE0MTQyOHww&ixlib=rb-4.1.0&q=85",
  avatar3:
    "https://images.unsplash.com/photo-1609371497456-3a55a205d5eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBkYXJrfGVufDB8fHx8MTc4NjE0MTQyOHww&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Platform", href: "#platform" },
  { label: "Partnership", href: "#partnership" },
  { label: "Contact", href: "#contact" },
];

export const STATS = [
  { value: "1200+", label: "Teams automating with FireFlink" },
  { value: "5×", label: "Faster test automation delivery" },
  { value: "900+", label: "Built-in scriptless NLP actions" },
  { value: "1500+", label: "Real devices in the cloud" },
];

export const FEATURES = [
  {
    tag: "NLP Authoring",
    title: "Automate in plain English",
    body: "Turn manual test cases into executable automation in plain English — no coding, no framework overhead. Your manual QAs start automating on day one.",
    image: IMAGES.dashboard,
  },
  {
    tag: "AI Self-Healing",
    title: "Locators that repair themselves",
    body: "The Smart Element Finder fetches changed locators at runtime, so a UI refactor no longer breaks your suite. Less maintenance, more coverage.",
    image: IMAGES.monitoring,
  },
  {
    tag: "Real Device Cloud",
    title: "Every device. One platform.",
    body: "Run parallel and distributed tests across 1500+ real Android, iOS devices and TVs — web, mobile, API, desktop and database, all unified.",
    image: IMAGES.serverCloud,
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Licensing & Procurement",
    body: "Buy FireFlink through a UK entity with GBP invoicing, local contracting and VAT handling. No overseas procurement friction.",
  },
  {
    no: "02",
    title: "Onboarding & Enablement",
    body: "Hands-on workshops that get your manual testers writing scriptless automation in days — not quarters. Tailored to your stack.",
  },
  {
    no: "03",
    title: "Implementation & Integration",
    body: "We wire FireFlink into your CI/CD, test data and reporting — Salesforce, SAP, Oracle Fusion or bespoke apps included.",
  },
  {
    no: "04",
    title: "Managed QA & Support",
    body: "Ongoing UK-based support, health checks and optional managed automation squads so your coverage keeps compounding.",
  },
];

export const COMPLIANCE = ["SOC 2 Type II", "GDPR", "HIPAA", "ISO 27001"];

export const MARQUEE_ITEMS = [
  "Web Testing",
  "Mobile Automation",
  "API Testing",
  "Desktop Apps",
  "Database Validation",
  "Salesforce",
  "SAP",
  "Oracle Fusion",
  "TV & OTT",
  "Cross-Browser",
];

export const TESTIMONIALS = [
  {
    quote:
      "Interlocked Solutions had our manual team building scriptless regression suites within a fortnight. Our release cycle dropped from 15 days of testing to under 2.",
    name: "Priya Nair",
    role: "Head of QA, Fintech Scale-up",
    avatar: IMAGES.avatar1,
  },
  {
    quote:
      "Having a UK partner for licensing, onboarding and support removed every procurement headache. FireFlink's AI self-healing is the real deal.",
    name: "Marcus Bellingham",
    role: "Engineering Director, Retail Group",
    avatar: IMAGES.avatar2,
  },
  {
    quote:
      "The implementation into our CI/CD was seamless. We now run parallel tests across real devices we never had access to before.",
    name: "Sofia Alvarez",
    role: "VP Platform, Healthtech",
    avatar: IMAGES.avatar3,
  },
];
